import type { Ref } from "vue";

import { toggleArrayValue } from "./toggleArrayValue";

export const updateFilterAndSearch = async <T>(filterRef: Ref<T[]>, value: T, searchFn: () => Promise<unknown>) => {
  toggleArrayValue(filterRef, value);
  await searchFn();
};
